















import { Vue, Component, Prop } from 'vue-property-decorator'
import about from '@/assets/data/ja/about.json'
import skills from '@/assets/data/ja/skills.json'

export type AboutTable = { 'key': string; 'value': string; 'url': string; }[]
export type Skills = typeof skills

@Component
export default class PairsTable extends Vue {
  @Prop() private items!: (AboutTable | Skills)
}
